const nuxtIcon: { aliases: { [key: string]: string } } = { aliases: {} };
/**
 * These apps are always present to any authenticated user
 */
const staticApps: AppConfig[] = [
  {
    name: 'Dashboard',
    slug: 'dashboard',
    icon: 'mdi:view-gallery-outline',
    show_in_nav: true,
  },
  {
    name: 'cccfpd.org',
    slug: 'cccfpdorg',
    icon: 'mdi:web',
    show_in_nav: true,
    external_link: 'https://cccfpd.org',
  },
  {
    name: 'Profile',
    slug: 'profile',
    icon: 'mdi:account-circle-outline',
    show_in_nav: false,
  },
];
/**
 * These app configs are used to populate and override details of the apps from the server
 */
const dynamicApps: AppConfig[] = [
  {
    name: 'Investigation Reports',
    slug: 'reports',
    icon: 'mdi:note-text-outline',
    show_in_nav: true,
    order: 5,
    nav_items: [
      {
        type: 'nav_item',
        text: 'Incidents',
        path: '/reports',
      },
      {
        type: 'nav_item',
        text: 'Search',
        path: '/reports/search',
      },
      {
        type: 'nav_item',
        text: 'Investigation Reports',
        path: '/reports/investigation-report?status=draft&p=1',
      },
      {
        type: 'nav_item',
        text: 'Property Sheets',
        path: '/reports/property-sheet',
      },
      {
        type: 'nav_item',
        text: 'Supplementals',
        path: '/reports/supplemental-report',
      },
      // {
      //   type: 'nav_item',
      //   text: 'Map',
      //   path: '/reports/map',
      // },
    ],
  },
  // {
  //   name: 'Electronic Signature Generator',
  //   slug: 'signature',
  //   menu_name: 'Signature Generator',
  //   icon: 'mdi:draw-pen',
  //   show_in_nav: true,
  // },
  // {
  //   name: 'Notifications',
  //   slug: 'notifications',
  //   icon: 'mdi:message-alert-outline',
  //   show_in_nav: true,
  //   group: 'Admin',
  // },
  {
    name: 'Roles & Permissions',
    slug: 'roles',
    icon: 'mdi:key-outline',
    show_in_nav: true,
    group: 'Admin',
  },
];

export default defineAppConfig({
  title: 'CCCFPD FIU Portal',
  layoutOrders: {
    navAndSidebar: 1,
    siteFooter: 5,
    pageFooter: 6,
    floatingActionButton: 10,
  },
  nuxtIcon,
  staticApps,
  dynamicApps,
});
